const SETTINGS_PAGE_INPUT_PAYLOAD_TEXT =
  'The input payload (application event, http api request or both) used to trigger the integration';

export { SETTINGS_PAGE_INPUT_PAYLOAD_TEXT };
